import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { GrEdit } from "react-icons/gr";
import {
  useAddFoodItemCountMutation,
  useGetMyOutletFoodItemsQuery,
} from "../slices/FoodItemSilce";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import FoodItemDetailsScreen from "./FoodItemDetailsScreen";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { useNavigate } from "react-router-dom";
import ReUsableModal from "../components/ReUsableModal";
import { toast } from "react-toastify";
import LazyMemberImage from "../components/LazyMemberImage";
import { CgPlayBackwards, CgPlayStopR } from "react-icons/cg";

const AllFoodItemsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);

  const [itemName, setItemName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [addQuantity, setAddQuantity] = useState("");
  const [newQuantity, setNewQuantity] = useState("");
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [showItemCountModal, setShowItemCountModal] = useState(false);
  const [searchFood, setSearchFood] = useState("");

  const navigate = useNavigate();

  const {
    data: foods,
    isLoading,
    refetch,
    error,
  } = useGetMyOutletFoodItemsQuery({ token: userInfo.token });

  const [addFoodItemCount, { isLoading: addingCount }] =
    useAddFoodItemCountMutation();

  const filteredFoods = foods?.filter((item) =>
    item.itemName.toLowerCase().includes(searchFood.toLowerCase())
  );

  useEffect(() => {
    if (!isLoading && !error) {
      refetch();
    }
  }, [isLoading, error, refetch]);

  useEffect(() => {
    if (quantity != null && addQuantity != null) {
      setNewQuantity(Number(quantity) + Number(addQuantity));
    }
  }, [quantity, addQuantity]);

  const addItemHandler = (item) => {
    setItemName(item?.itemName);
    setQuantity(item?.itemQuantity);
    setNewQuantity(item?.itemQuantity);
    setSelectedItemId(item._id);
    setShowItemCountModal(true);
  };

  const submitAddFoodItem = async () => {
    try {
      const data = {
        _id: selectedItemId,
        itemCount: addQuantity,
        token: userInfo.token,
      };

      await addFoodItemCount(data).unwrap();
      await refetch();
      setShowItemCountModal(false);
      toast.success(" Item quantity updated Successfully");
    } catch (err) {
      console.error("Error adding food count:", err);
    }
  };

  const handleCancelEdit = () => {
    setAddQuantity("");
    setNewQuantity("");
    setShowItemCountModal(false);
  };

  return (
    <>
      <ReUsableModal
        title="Add Food Count"
        payload={[
          {
            fieldName: "Item Name",
            fieldType: "text",
            fieldValue: itemName,
            setMethod: setItemName,
            disabled: true,
          },
          {
            fieldName: "Existing Quantity",
            fieldType: "number",
            fieldValue: quantity,
            setMethod: setQuantity,
            disabled: true,
          },
          {
            fieldName: "Add Quantity",
            fieldType: "number",
            fieldValue: addQuantity,
            setMethod: setAddQuantity,
          },
          {
            fieldName: "New Quantity",
            fieldType: "number",
            fieldValue: newQuantity,
            setMethod: setNewQuantity,
            disabled: true,
          },
        ]}
        show={showItemCountModal}
        size="md"
        onHide={() => handleCancelEdit(false)}
        onSubmit={submitAddFoodItem}
        submit="Submit"
        cancel="Cancel"
      />
      <Row className="mt-4">
        <h5>All Foods</h5>

        <Form.Control
          type="text"
          placeholder="Search food items..."
          className="mb-3"
          value={searchFood}
          onChange={(e) => {
            const val = e.target.value.replace(/[0-9]/g, "");
            setSearchFood(val);
          }}
        />

        <Col>
          {searchFood?.length > 0 && (
            <h6 style={{ color: "red" }}>You are seeing searched food items</h6>
          )}
          {isLoading ? (
            <Loader />
          ) : error ? (
            <Message>
              {error?.data?.error || "Error fetching food items"}
            </Message>
          ) : (
            <Table
              striped
              bordered
              hover
              responsive="sm"
              className="table-custom"
            >
              <thead className={`${userInfo.themeColor}ThemeThead`}>
                <tr>
                  <th></th>
                  <th>Item Name</th>
                  <th>Outlet Id</th>
                  <th>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {filteredFoods?.length > 0 ? (
                  filteredFoods.map((item) => (
                    <tr key={item._id}>
                      <td>
                        <td>
                          <LazyMemberImage
                            foodItemId={item._id}
                            imageUpdatedTimeFromDB={item.imageUploadedTime}
                            currentlySelling={item.currentlySelling}
                            photoUploaded={item.imageUploaded}
                          />
                        </td>
                      </td>
                      <td>
                        <a
                          onClick={() =>
                            navigate(`/foodItem/${item._id}`, {
                              state: { from: "allFoodItems", showEdit: true },
                            })
                          }
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          {item?.itemName}
                        </a>{" "}
                        {item.isVeg ? (
                          <CgPlayStopR
                            style={{ color: "green", width: "0.7rem" }}
                          />
                        ) : (
                          <CgPlayStopR
                            style={{ color: "red", width: "0.7rem" }}
                          />
                        )}
                      </td>
                      <td>{item?.outletId?._id}</td>
                      <td>
                        <span
                          style={{
                            color: item.itemQuantity < 10 && "red",
                            fontSize: "1.1rem",
                            marginRight: "0.5rem",
                          }}
                        >
                          {item.itemQuantity}
                        </span>
                        <GrEdit
                          style={{ cursor: "pointer" }}
                          onClick={() => addItemHandler(item)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4}>
                      <Message>No food items found.</Message>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Col>
      </Row>
    </>
  );
};

export default AllFoodItemsScreen;
